<template>
    <v-col cols="12">
        <v-row class="ml-2 pt-1">
            <v-col cols="8" class="py-0 py-sm-2">
                    <span class="text-body-1 grey--text text--darken-3 font-weight-bold">{{ $t('order') }}&nbsp;№{{index + 1}}</span>
            </v-col>
            <v-col cols="4" class="py-0 py-sm-2">
                <div class="float-right font-weight-medium pr-sm-4 d-none d-sm-flex">
                    <span class="text-body-1 font-weight-bold justify-content-end">{{ $t('sum') }}: {{summaryPrice}} {{currency.cyrName.toLowerCase()}}</span>
                </div>
                <div class="d-flex d-sm-none float-right">
                    <v-btn
                        small
                        icon
                        :to="{name: 'Basket'}"
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row class="px-2 px-sm-4">
            <v-col cols="8" class="pb-0">
                <span class="text-body-2 text-md-body-1 font-weight-bold text-uppercase">
                    {{ sellerTitle }}
                </span>
            </v-col>
            <v-col cols="4" class="pb-0">
                <div class="float-right font-weight-medium pr-sm-4 d-none d-sm-flex">
                    <router-link
                        class="teal--text"
                        :to="{name: 'Basket'}"
                    >{{ $t('edit') }}</router-link>
                </div>
                <div class="float-right font-weight-medium pr-sm-4 d-flex d-sm-none">
                    <span class="text-body-1 font-weight-bold justify-content-end">{{ $t('sum') }}: {{summaryPrice}} {{currency.cyrName.toLowerCase()}}</span>
                </div>
            </v-col>
        </v-row>
            <template
                v-for="product in order.data"
            >
                <v-row class="d-flex flex-wrap px-2 px-sm-4">
                    <v-col cols="12">
                        <product-item
                            :product="product"
                            @order-change="orderChange"
                        ></product-item>
                    </v-col>
                </v-row>
                <v-divider class="my-1"></v-divider>
            </template>
        <v-row class="d-flex flex-wrap px-2 px-sm-4">
            <v-col cols="12" class="pb-0 pt-5">
                <span class="text-body-1 grey--text text--darken-3 font-weight-medium">{{ $t('addressDelivery') }}</span>
            </v-col>
            <v-col cols="12" sm="4" class="py-0">
                <v-autocomplete
                    v-model="formData.region"
                    :items="regions"
                    hide-no-data
                    item-text="name"
                    item-value="id"
                    item-color="orange lighten-2"
                    :label="$t('region')"
                    return-object
                    color="orange lighten-2"
                    @change="regionChange"
                    :rules="rules.text"
                    required
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" class="py-0">
                <v-autocomplete
                    v-model="formData.geo"
                    :items="settlements"
                    hide-no-data
                    item-text="name"
                    item-value="id"
                    item-color="orange lighten-2"
                    :label="$t('settlement')"
                    return-object
                    color="orange lighten-2"
                    :disabled="!settlements.length"
                    :loading="settlementsLoad"
                    :rules="rules.text"
                    required
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" class="py-0">
                <v-text-field
                    v-model="formData.address"
                    :label="$t('address')"
                    color="orange lighten-2"
                    :rules="rules.text"
                    required
                ></v-text-field>
            </v-col>
        </v-row>
        <v-divider class="my-1"></v-divider>
        <div class="d-flex flex-wrap my-2 px-2 px-sm-4">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        info_outlined
                    </v-icon>
                </template>
                <span>{{ $t('setRecommendOrderDate') }}</span>
            </v-tooltip>
            <div>
                <span class="pr-2">{{ $t('deliveryDate') }}:</span>
                <delivery-date :dialog-data="order.seller" @date-change="orderDateChange"></delivery-date>
            </div>
        </div>
        <v-divider class="my-1"></v-divider>
        <div class="d-flex flex-wrap my-2 px-2 px-sm-4">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        info_outlined
                    </v-icon>
                </template>
                <span>{{ $t('paymentWaySet') }}</span>
            </v-tooltip>
            <span class="pr-2">{{ $t('paymentMethod') }}:</span>
            <div>
                <payment-method
                    :dialog-data="order.seller"
                    :policies="orderPolicies.paymentPolicy"
                    :payment-ways="paymentWays"
                    @payment-change="orderPaymentChange"
                ></payment-method>
            </div>
        </div>
        <v-divider class="my-1"></v-divider>
        <v-row class="d-flex flex-wrap px-2 px-sm-4">
            <v-col cols="12" class="mt-2">
                <span class="text-body-1 grey--text text--darken-3 font-weight-medium">{{ $t('messagesToSeller') }}</span>
            </v-col>
            <v-col cols="12" class="py-0">
                <v-textarea
                    v-model="message"
                    color="orange lighten-2"
                    outlined
                    :hide-details="true"
                    :label="$t('messageText')"
                    :placeholder="`${$t('hello')} ...`"
                ></v-textarea>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import DeliveryDate from "../../basket/v-2/DeliveryDate";
import PaymentMethod from "../../basket/v-2/PaymentMethod";
import ProductItem from "../ProductItem"

import OrderCalculator from "../../../../app-front/mixins/OrderCalculator";
import OrderDataProvider from "../../../../app-front/mixins/OrderDataProvider";

import GeoService from "../../../../app-front/services/api/GeoService";
import OrderService from "../../../../app-front/services/api/OrderService";
import numberFormat from "../../../../utils/numberFormat";

export default {
    name: "OrderItem",
    components: {
        DeliveryDate,
        PaymentMethod,
        ProductItem
    },
    mixins: [OrderCalculator, OrderDataProvider],
    props: [ "index", "order" ],
    data() {
        return {
            date: null,
            paymentWay: null,
            paymentWays: [],
            creditPolicy: null,
            formData: {},
            message: '',
            rules: {
                text: [
                    v => !!v || this.$t('requiredField'),
                ],
            },
            settlements: [],
            settlementsLoad: false,
        }
    },
    computed: {
        currency() {
            return this.$store.getters.currencies.find(item => item.id === 1);
        },
        sellerTitle() {
            if (!this.order.seller) return '';

            return this.order.seller.companyName || `${this.order.seller.lastName} ${this.order.seller.firstName}`
        },
        summaryPrice() {
            const price = this.orderCalculatedPrice ? parseFloat(this.orderCalculatedPrice) : 0;
            return numberFormat(price, 2, '.', ' ')
        },
        regions() {
            return this.$store.state.geo.regions;
        },
        inProcessOrder() {
            const inProcess = this.inProcessProducts || [];
            return inProcess.find(item => item.sellerID === this.order.seller.id);
        },
        orderProducts() {
            return this.inProcessOrder ? this.inProcessOrder.products : [];
        },
        orderPolicies() {
            return this.order.policies;
        }
    },
    methods: {
        orderChange(data) {
            if (!data.price) {
                this.$store.commit('orderInProcessClearProduct', data.id);
            } else {
                const emitData = {
                    product: data,
                    policies: this.orderPolicies,
                    date: this.date,
                    paymentWay: this.paymentWay,
                    sellerID: this.order.seller.id
                };
                this.updateProductsInProcess(emitData);
            }

            this.calculatePrice();
        },
        orderDateChange(dateValue) {
            this.date = dateValue;
            this.setOrderDate({sellerID: this.order.seller.id, date: this.date});
            this.updateOrderDate({sellerID: this.order.seller.id, value: this.date});
            this.calculatePrice();
        },
        orderPaymentChange(data) {
            this.paymentWay = data.value;
            this.creditPolicy = data.creditPolicy;
            this.setOrderPayment({
                sellerID: this.order.seller.id,
                creditPolicy: this.creditPolicy,
                paymentWay: this.paymentWay
            });
            this.updateOrderCreditPolicy({sellerID: this.order.seller.id, value: this.creditPolicy});
            this.updateOrderPaymentWay({sellerID: this.order.seller.id, value: this.paymentWay});
            this.calculatePrice();
        },
        regionChange() {
            this.settlementsLoad = true;
            this.settlements = [];
            this.formData.geo = null;
            GeoService.setLocale(this.$store.state.language.appLanguage);
            GeoService.getChildrenSettlements(this.formData.region.id)
                .then(res => {
                    this.settlements = res.data;
                    this.settlementsLoad = false;
                })
                .catch(err => console.log(err))
        },
        setFormDataToOrder() {
            const delivery = {
                region: this.formData.region,
                geo: this.formData.geo,
                address: this.formData.address,
            };
            this.setOrderProductsDelivery({
                sellerID: this.order.seller.id,
                delivery: delivery,
                message: this.message
            });
        },
        getPaymentWays() {
            OrderService.getActivePaymentWays({ self: false })
                .then(res => {
                    this.paymentWays = res.data;
                })
                .catch(console.log)
        },
    },
    mounted() {
        this.getPaymentWays();
    },
    watch: {
        formData: {
            handler() {
                this.setFormDataToOrder();
            },
            deep: true,
        },
        message() {
            this.setFormDataToOrder();
        }
    }
}
</script>

<style scoped>

</style>
